const headerEmailCopy = (linkSelector) => {
    const emailLink = document.querySelector(linkSelector);
    emailLink && emailLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const emailAddress = emailLink.dataset.email;
        emailAddress && navigator.clipboard.writeText(emailAddress);
    });
};
export default headerEmailCopy;
